import React from "react";
import { Dropdown, Menu, Badge } from "antd";
import { Link } from "react-router-dom";
import { ProjectOutlined, MenuOutlined } from "@ant-design/icons";
import "./Nav.css";

export function Nav(props) {
  const scenariosMenu = (
    <Menu>
      <Menu.Item>
        <a
          href="#add"
          onClick={(e) => {
            e.preventDefault();
            props
              .actionScenarioAdd({
                name: "My New Scenario",
                users: [props.user.id],
              })
              .then((res) => {
                props.history.push(`/scenario/${res.payload.data.id}`);
              });
          }}
        >
          <b>Create new Scenario +</b>
        </a>
      </Menu.Item>
      {props.user.scenarios && props.user.scenarios.length > 0 && <Menu.Divider /> }
      {props.user &&
        props.user.scenarios &&
        props.user.scenarios.map((item, index) => (
          <Menu.Item key={index}>
            {item && item.id && (
              <Link to={`/scenario/${item.id}`}>{item.name}</Link>
            )}
          </Menu.Item>
        ))}
    </Menu>
  );

  const staticSiteUrl = "https://treeequityscore.org/";
  const staticSiteMenu = (
    <Menu>
      <Menu.Item>
        <a
          rel="noopener noreferrer"
          href={`${staticSiteUrl}about`}
          target="_blank"
        >
          About
        </a>
      </Menu.Item>
      <Menu.Item>
        <a
          rel="noopener noreferrer"
          href={`${staticSiteUrl}methodology`}
          target="_blank"
        >
          Methodology
        </a>
      </Menu.Item>
      <Menu.Item>
        <a
          rel="noopener noreferrer"
          href={`${staticSiteUrl}dictionary`}
          target="_blank"
        >
          Data Dictionary
        </a>
      </Menu.Item>
      <Menu.Item>
        <a
          rel="noopener noreferrer"
          href={`${staticSiteUrl}datasources`}
          target="_blank"
        >
          Data Sources
        </a>
      </Menu.Item>
      <Menu.Item>
        <a
          rel="noopener noreferrer"
          href={`${staticSiteUrl}privacy`}
          target="_blank"
        >
          Privacy
        </a>
      </Menu.Item>
      <Menu.Item>
        <a
          rel="noopener noreferrer"
          href={`${staticSiteUrl}FAQ`}
          target="_blank"
        >
          FAQ
        </a>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item>
        {props.user.email ? (
          <a
            href="#sign-out"
            onClick={(e) => {
              e.preventDefault();
              props.actionUserSignOut();
              setTimeout(() => {
                window.location.href = "/";
              }, 100);
            }}
          >
            Sign out
          </a>
        ) : (
          <Link to="/login">Sign in</Link>
        )}
      </Menu.Item>
    </Menu>
  );

  const { user } = props;

  return (
    <div className="nav">
      <a className="brand" href="/" title="Tree Equity Score Analyzer">
        <img
          className="nav__logo-image"
          src="/assets/tree-equity-score-logo-analyzer.png"
          alt="Tree Equity Score Analyzer"
          width="150"
          height="100"
        />
      </a>
      <div className="site-title">Rhode Island</div>

      <div className="static-site">
        <Dropdown
          overlay={staticSiteMenu}
          overlayClassName={"user-links"}
          trigger={"click"}
          overlayStyle={{
            zIndex: 10000,
          }}
        >
          <a
            className="ant-dropdown-link"
            href="#TODO"
            onClick={(e) => e.preventDefault()}
          >
            <MenuOutlined /> <b>Menu</b>
          </a>
        </Dropdown>
      </div>
      {user?.email && (
        <>
          <div className="user-scenarios">
            <Dropdown
              overlay={scenariosMenu}
              overlayClassName={"user-links"}
              trigger={"click"}
              overlayStyle={{
                zIndex: 10000,
              }}
            >
              <a
                className="ant-dropdown-link"
                href="#TODO"
                onClick={(e) => e.preventDefault()}
              >
                <ProjectOutlined /> <b>My Scenarios <Badge count={props.user.scenarios.length} className="badge" showZero={true} /></b>
              </a>
            </Dropdown>
          </div>
        </>
      )}
    </div>
  );
}
